import { c as _c } from "react/compiler-runtime";
import { DropdownFilterChip } from "@components/common/faro-table/faro-table-filter/dropdown-filter-chip";
import { useProjectMarkupsFilterLists } from "@pages/project-details/project-markups/project-markups-filters/project-markups-filter-list";
import { ProjectMarkupsTableHeaders } from "@pages/project-details/project-markups/project-markups-table-utils";
import { TableType } from "@utils/track-event/track-event-list";

/** Show filters and apply them for project markup status */
export function ProjectMarkupsStatusFilter() {
  const $ = _c(4);
  const allFilters = useProjectMarkupsFilterLists();
  let t0;
  if ($[0] !== allFilters.Status) {
    t0 = allFilters.Status ?? {};
    $[0] = allFilters.Status;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <DropdownFilterChip label={ProjectMarkupsTableHeaders.status} filteredColumn={ProjectMarkupsTableHeaders.status} items={t0} shouldShowSearchBox={false} shouldShowCheckbox={true} shouldAllowLabelTranslation={true} tableType={TableType.projectMarkups} />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}